export default [
  {
    lang: "abkhaz",
    code: "ab",
  },
  {
    lang: "afar",
    code: "aa",
  },
  {
    lang: "afrikaans",
    code: "af",
  },
  {
    lang: "akan",
    code: "ak",
  },
  {
    lang: "albanian",
    code: "sq",
  },
  {
    lang: "amharic",
    code: "am",
  },
  {
    lang: "arabic",
    code: "ar",
  },
  {
    lang: "aragonese",
    code: "an",
  },
  {
    lang: "armenian",
    code: "hy",
  },
  {
    lang: "assamese",
    code: "as",
  },
  {
    lang: "avaric",
    code: "av",
  },
  {
    lang: "avestan",
    code: "ae",
  },
  {
    lang: "aymara",
    code: "ay",
  },
  {
    lang: "azerbaijani",
    code: "az",
  },
  {
    lang: "bambara",
    code: "bm",
  },
  {
    lang: "bashkir",
    code: "ba",
  },
  {
    lang: "basque",
    code: "eu",
  },
  {
    lang: "belarusian",
    code: "be",
  },
  {
    lang: "bengali",
    code: "bn",
  },
  {
    lang: "bihari",
    code: "bh",
  },
  {
    lang: "bislama",
    code: "bi",
  },
  {
    lang: "bosnian",
    code: "bs",
  },
  {
    lang: "breton",
    code: "br",
  },
  {
    lang: "bulgarian",
    code: "bg",
  },
  {
    lang: "burmese",
    code: "my",
  },
  {
    lang: "catalan",
    code: "ca",
  },
  {
    lang: "chamorro",
    code: "ch",
  },
  {
    lang: "chechen",
    code: "ce",
  },
  {
    lang: "chichewa",
    code: "ny",
  },
  {
    lang: "chinese",
    code: "zh",
  },
  {
    lang: "chuvash",
    code: "cv",
  },
  {
    lang: "cornish",
    code: "kw",
  },
  {
    lang: "corsican",
    code: "co",
  },
  {
    lang: "cree",
    code: "cr",
  },
  {
    lang: "croatian",
    code: "hr",
  },
  {
    lang: "czech",
    code: "cs",
  },
  {
    lang: "danish",
    code: "da",
  },
  {
    lang: "divehi",
    code: "dv",
  },
  {
    lang: "dutch",
    code: "nl",
  },
  {
    lang: "dzongkha",
    code: "dz",
  },
  {
    lang: "english",
    code: "en",
  },
  {
    lang: "esperanto",
    code: "eo",
  },
  {
    lang: "estonian",
    code: "et",
  },
  {
    lang: "ewe",
    code: "ee",
  },
  {
    lang: "faroese",
    code: "fo",
  },
  {
    lang: "fijian",
    code: "fj",
  },
  {
    lang: "finnish",
    code: "fi",
  },
  {
    lang: "french",
    code: "fr",
  },
  {
    lang: "fula",
    code: "ff",
  },
  {
    lang: "galician",
    code: "gl",
  },
  {
    lang: "georgian",
    code: "ka",
  },
  {
    lang: "german",
    code: "de",
  },
  {
    lang: "greek",
    code: "el",
  },
  {
    lang: "guaraní",
    code: "gn",
  },
  {
    lang: "gujarati",
    code: "gu",
  },
  {
    lang: "haitian",
    code: "ht",
  },
  {
    lang: "hausa",
    code: "ha",
  },
  {
    lang: "hebrew",
    code: "he",
  },
  {
    lang: "herero",
    code: "hz",
  },
  {
    lang: "hindi",
    code: "hi",
  },
  {
    lang: "hiri motu",
    code: "ho",
  },
  {
    lang: "hungarian",
    code: "hu",
  },
  {
    lang: "interlingua",
    code: "ia",
  },
  {
    lang: "indonesian",
    code: "id",
  },
  {
    lang: "interlingue",
    code: "ie",
  },
  {
    lang: "irish",
    code: "ga",
  },
  {
    lang: "igbo",
    code: "ig",
  },
  {
    lang: "inupiaq",
    code: "ik",
  },
  {
    lang: "ido",
    code: "io",
  },
  {
    lang: "icelandic",
    code: "is",
  },
  {
    lang: "italian",
    code: "it",
  },
  {
    lang: "inuktitut",
    code: "iu",
  },
  {
    lang: "japanese",
    code: "ja",
  },
  {
    lang: "javanese",
    code: "jv",
  },
  {
    lang: "kalaallisut",
    code: "kl",
  },
  {
    lang: "kannada",
    code: "kn",
  },
  {
    lang: "kanuri",
    code: "kr",
  },
  {
    lang: "kashmiri",
    code: "ks",
  },
  {
    lang: "kazakh",
    code: "kk",
  },
  {
    lang: "khmer",
    code: "km",
  },
  {
    lang: "kikuyu",
    code: "ki",
  },
  {
    lang: "kinyarwanda",
    code: "rw",
  },
  {
    lang: "kyrgyz",
    code: "ky",
  },
  {
    lang: "komi",
    code: "kv",
  },
  {
    lang: "kongo",
    code: "kg",
  },
  {
    lang: "korean",
    code: "ko",
  },
  {
    lang: "kurdish",
    code: "ku",
  },
  {
    lang: "kwanyama",
    code: "kj",
  },
  {
    lang: "latin",
    code: "la",
  },
  {
    lang: "luxembourgish",
    code: "lb",
  },
  {
    lang: "ganda",
    code: "lg",
  },
  {
    lang: "limburgish",
    code: "li",
  },
  {
    lang: "lingala",
    code: "ln",
  },
  {
    lang: "lao",
    code: "lo",
  },
  {
    lang: "lithuanian",
    code: "lt",
  },
  {
    lang: "luba-katanga",
    code: "lu",
  },
  {
    lang: "latvian",
    code: "lv",
  },
  {
    lang: "manx",
    code: "gv",
  },
  {
    lang: "macedonian",
    code: "mk",
  },
  {
    lang: "malagasy",
    code: "mg",
  },
  {
    lang: "malay",
    code: "ms",
  },
  {
    lang: "malayalam",
    code: "ml",
  },
  {
    lang: "maltese",
    code: "mt",
  },
  {
    lang: "māori",
    code: "mi",
  },
  {
    lang: "marathi",
    code: "mr",
  },
  {
    lang: "marshallese",
    code: "mh",
  },
  {
    lang: "mongolian",
    code: "mn",
  },
  {
    lang: "nauru",
    code: "na",
  },
  {
    lang: "navajo",
    code: "nv",
  },
  {
    lang: "northern ndebele",
    code: "nd",
  },
  {
    lang: "nepali",
    code: "ne",
  },
  {
    lang: "ndonga",
    code: "ng",
  },
  {
    lang: "norwegian bokmål",
    code: "nb",
  },
  {
    lang: "norwegian nynorsk",
    code: "nn",
  },
  {
    lang: "norwegian",
    code: "no",
  },
  {
    lang: "nuosu",
    code: "ii",
  },
  {
    lang: "southern ndebele",
    code: "nr",
  },
  {
    lang: "occitan",
    code: "oc",
  },
  {
    lang: "ojibwe",
    code: "oj",
  },
  {
    lang: "old church slavonic",
    code: "cu",
  },
  {
    lang: "oromo",
    code: "om",
  },
  {
    lang: "oriya",
    code: "or",
  },
  {
    lang: "ossetian",
    code: "os",
  },
  {
    lang: "panjabi",
    code: "pa",
  },
  {
    lang: "pāli",
    code: "pi",
  },
  {
    lang: "persian",
    code: "fa",
  },
  {
    lang: "polish",
    code: "pl",
  },
  {
    lang: "pashto",
    code: "ps",
  },
  {
    lang: "portuguese",
    code: "pt",
  },
  {
    lang: "quechua",
    code: "qu",
  },
  {
    lang: "romansh",
    code: "rm",
  },
  {
    lang: "kirundi",
    code: "rn",
  },
  {
    lang: "romanian",
    code: "ro",
  },
  {
    lang: "russian",
    code: "ru",
  },
  {
    lang: "sanskrit",
    code: "sa",
  },
  {
    lang: "sardinian",
    code: "sc",
  },
  {
    lang: "sindhi",
    code: "sd",
  },
  {
    lang: "northern sami",
    code: "se",
  },
  {
    lang: "samoan",
    code: "sm",
  },
  {
    lang: "sango",
    code: "sg",
  },
  {
    lang: "serbian",
    code: "sr",
  },
  {
    lang: "gaelic",
    code: "gd",
  },
  {
    lang: "shona",
    code: "sn",
  },
  {
    lang: "sinhala",
    code: "si",
  },
  {
    lang: "slovak",
    code: "sk",
  },
  {
    lang: "slovene",
    code: "sl",
  },
  {
    lang: "somali",
    code: "so",
  },
  {
    lang: "southern sotho",
    code: "st",
  },
  {
    lang: "spanish",
    code: "es",
  },
  {
    lang: "sundanese",
    code: "su",
  },
  {
    lang: "swahili",
    code: "sw",
  },
  {
    lang: "swati",
    code: "ss",
  },
  {
    lang: "swedish",
    code: "sv",
  },
  {
    lang: "tamil",
    code: "ta",
  },
  {
    lang: "telugu",
    code: "te",
  },
  {
    lang: "tajik",
    code: "tg",
  },
  {
    lang: "thai",
    code: "th",
  },
  {
    lang: "tigrinya",
    code: "ti",
  },
  {
    lang: "tibetan standard",
    code: "bo",
  },
  {
    lang: "turkmen",
    code: "tk",
  },
  {
    lang: "tagalog",
    code: "tl",
  },
  {
    lang: "tswana",
    code: "tn",
  },
  {
    lang: "tonga",
    code: "to",
  },
  {
    lang: "turkish",
    code: "tr",
  },
  {
    lang: "tsonga",
    code: "ts",
  },
  {
    lang: "tatar",
    code: "tt",
  },
  {
    lang: "twi",
    code: "tw",
  },
  {
    lang: "tahitian",
    code: "ty",
  },
  {
    lang: "uyghur",
    code: "ug",
  },
  {
    lang: "ukrainian",
    code: "uk",
  },
  {
    lang: "urdu",
    code: "ur",
  },
  {
    lang: "uzbek",
    code: "uz",
  },
  {
    lang: "venda",
    code: "ve",
  },
  {
    lang: "vietnamese",
    code: "vi",
  },
  {
    lang: "volapük",
    code: "vo",
  },
  {
    lang: "walloon",
    code: "wa",
  },
  {
    lang: "welsh",
    code: "cy",
  },
  {
    lang: "wolof",
    code: "wo",
  },
  {
    lang: "western frisian",
    code: "fy",
  },
  {
    lang: "xhosa",
    code: "xh",
  },
  {
    lang: "yiddish",
    code: "yi",
  },
  {
    lang: "yoruba",
    code: "yo",
  },
  {
    lang: "zhuang",
    code: "za",
  },
  {
    lang: "zulu",
    code: "zu",
  },
]
